import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

export default function PortfolioForm() {

  $('#portfolio_status_field').on('typeahead:select typeahead:autocomplete', function(ev, suggestion) {

    if (suggestion.toLowerCase() === 'household') {
      ToastCustom({title: 'Invalid Selection', message: 'The "Household" status cannot be selected here. Please choose a different status.', delay: 3000, type: 'warning'});
      $('#portfolio_status_field').typeahead('val', '');
      $('#hidden_portfolio_status').val('');
      return;
    }

    $('#hidden_portfolio_status').val(suggestion.toLowerCase());
  });

  $('#portfolio-form').on('submit', function(ev) {
    let nameField = $('#portfolio_name').val();
    let statusField = $('#portfolio_status_field').val();
    let dateField = $('#portfolio_holdings_as_of').val();

    // Validate Name
    if (nameField.trim() === '') {
      ev.preventDefault();
      ToastCustom({title: 'Name Required', message: 'Please enter a name for the Portfolio.', delay: 3000, type: 'warning'});
      return;
    }

    // Validate Status
    if (statusField === '') {
      ev.preventDefault();
      ToastCustom({title: 'Status Required', message: 'Please select a valid status for the Portfolio.', delay: 3000, type: 'warning'});
      return;
    }

    // Validate DateField
    if (dateField === '') {
      ev.preventDefault();
      ToastCustom({title: 'Holdings Date Required', message: 'Please select a "Holdings As Of" date for the Portfolio.', delay: 3000, type: 'warning'});
      return;
    }
  });
}